export const SPORT_AREAS = [
  "Командні та ігрові",
  "Ракеткові",
  "Фітнес-інвентар",
  "Тренажери та силове",
  "Плавання та дайвінг",
  "Зимові види спорту",
  "Бокс та єдиноборства",
  "Спортивне харчування",
  "Інше",
];

const SECTIONS_BY_AREA = {
  // Командні та ігрові
  "Командні та ігрові": [
    "Мʼячі (футбол/баскетбол/волейбол/футзал/гандбол/регбі/гольф)",
    "Дартс",
    "Бейсбол",
  ],

  // Ракеткові
  "Ракеткові": [
    "Настільний теніс",
    "Бадмінтон / Сквош",
  ],

  // Фітнес-інвентар
  "Фітнес-інвентар": [
    "Еспандери",
    "Скакалки",
    "Гумки для фітнесу",
    "Палиці / Бодібари",
    "Упори для віджимань",
    "Ролики для преса",
    "Обручі (хулахуп)",
    "Фітнес-мʼячі",
  ],

  // Тренажери та силове
  "Тренажери та силове": [
    "Кардіо (бігові доріжки/велотренажери/орбітреки)",
    "Силові тренажери / Станції",
    "Турніки / Бруси / Шведські стіни",
    "Вільні ваги (гантелі/штанги/гири)",
    "Батути",
  ],

  // Плавання та дайвінг
  "Плавання та дайвінг": [
    "Окуляри / Маски",
    "Шапочки",
    "Ласти",
    "Трубки / Беруші / Затискачі",
    "Аксесуари для басейну",
  ],

  // Зимові
  "Зимові види спорту": [
    "Лижі та аксесуари",
    "Сноуборди та аксесуари",
    "Ковзани",
    "Санки",
    "Черевики (гірськолижні)",
  ],

  // Бокс
  "Бокс та єдиноборства": [
    "Рукавиці",
    "Мішки / Груші",
    "Лапи / Маківари",
  ],

  // Харчування
  "Спортивне харчування": [],

  // Інше
  "Інше": ["Інше спортивне"],
};

const SUBCATS_BY_SECTION = {
  // Командні та ігрові
  "Мʼячі (футбол/баскетбол/волейбол/футзал/гандбол/регбі/гольф)": [
    "Футбольні",
    "Баскетбольні",
    "Волейбольні",
    "Футзал",
    "Гандбольні",
    "Для регбі",
    "Для гольфу",
  ],
  "Дартс": ["Дошки / Набори", "Аксесуари"],
  "Бейсбол": ["Рукавички", "Біти", "Набори"],

  // Ракеткові
  "Настільний теніс": ["Ракетки", "Мʼячі", "Сітки", "Столи", "Чохли", "Набори"],
  "Бадмінтон / Сквош": ["Ракетки", "Сітки", "Набори", "Чохли"],

  // Фітнес-інвентар — без підкатів
  "Еспандери": [],
  "Скакалки": [],
  "Гумки для фітнесу": [],
  "Палиці / Бодібари": [],
  "Упори для віджимань": [],
  "Ролики для преса": [],
  "Обручі (хулахуп)": [],
  "Фітнес-мʼячі": [],

  // Тренажери та силове
  "Кардіо (бігові доріжки/велотренажери/орбітреки)": [],
  "Силові тренажери / Станції": [],
  "Турніки / Бруси / Шведські стіни": [],
  "Вільні ваги (гантелі/штанги/гири)": [],
  "Батути": [],

  // Плавання та дайвінг
  "Окуляри / Маски": [],
  "Шапочки": [],
  "Ласти": [],
  "Трубки / Беруші / Затискачі": [],
  "Аксесуари для басейну": [],

  // Зимові
  "Лижі та аксесуари": [],
  "Сноуборди та аксесуари": [],
  "Ковзани": [],
  "Санки": [],
  "Черевики (гірськолижні)": [],

  // Бокс
  "Рукавиці": [],
  "Мішки / Груші": [],
  "Лапи / Маківари": [],

  // Харчування / Інше
  "Інше спортивне": [],
};

export const sportFields = (attrs) => {
  const a = attrs || {};
  const area = a.area || "";
  const section = a.section || "";

  const areaOnly = [
    {
      name: "area",
      label: "Напрям / Вид спорту *",
      type: "select",
      options: SPORT_AREAS,
      required: true,
    },
  ];
  if (!area) return areaOnly;

  if (area === "Спортивне харчування") {
    return areaOnly;
  }

  const sectionOnly = [
    ...areaOnly,
    {
      name: "section",
      label: "Розділ",
      type: "select",
      options: SECTIONS_BY_AREA[area] || [],
      required: false,
    },
  ];
  if (!section) return sectionOnly;

  const subcats = SUBCATS_BY_SECTION[section] || [];
  if (!subcats.length) return sectionOnly;

  return [
    ...sectionOnly,
    {
      name: "subcategory",
      label: "Підкатегорія",
      type: "select",
      options: subcats,
      required: false,
    },
  ];
};

export const sportsFields = sportFields;
